import { useEffect } from "react";
import FBTrackingService from "@/services/fbTrackingService";

/**
 * Automatically tracks when a component is shown/mounted
 * @param eventName - The tracking event name
 * @param eventData - Optional data to attach to the event
 */
export function useTrackImpression(eventName: string, eventData?: any) {
  useEffect(() => {
    FBTrackingService.trackEvent(eventName, { eventData });
  }, [eventName, eventData]);
}
